import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Image from 'components/Image';
import Link from 'components/Link';
import { bindGa } from 'helpers/analytics';
import { getImageFromImageObject } from 'components/Image/utils';
import s from './Accordion.scss';

class Accordion extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      activeIndex: 0,
    };
  }

  onItemClick(e, index) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({
      activeIndex: index,
    });
  }

  @bindGa({})
  // eslint-disable-next-line class-methods-use-this
  onActiveItemClick() {
    // dummy fn to capture ga
  }

  render() {
    const { data, newga } = this.props;
    return (
      <div>
        {data &&
          data.length > 0 &&
          data.map((item, index) => {
            const imageSrc = getImageFromImageObject(
              item.image || { id: item.imageid, version: item.imagesize },
            );
            return (
              <div
                className={classNames({
                  [`${s.movieReview}`]: true,
                  // [`${s.active} moviereview_active`]:
                  // index === this.state.activeIndex,
                })}
                key={item.id}
              >
                <Link
                  to={item.wu}
                  onClick={e => {
                    if (this.state.activeIndex !== index) {
                      this.onItemClick(e, index);
                    } else {
                      this.onActiveItemClick(e);
                    }
                  }}
                  data-newga={`${newga}/${index}/${item.wu}`}
                >
                  <Image src={imageSrc} lazyload alt="" />
                  <div className={s.content}>
                    {/* <h6>Movie Review</h6> */}
                    <h2>{item.hl}</h2>
                    <p>{item.syn || item.des}</p>
                    <div className={s.flexbox}>
                      <span>Critic Rating</span>
                      <span className={s.rating}>{item.rating}</span>
                    </div>
                  </div>
                </Link>
              </div>
            );
          })}
      </div>
    );
  }
}

Accordion.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  newga: PropTypes.string,
};

Accordion.defaultProps = {
  newga: 'Accordian',
};

export default Accordion;
